<template>
  <div class="card mr-2">
    <div
      class="header border-bottom accordian-toggle"
      v-b-toggle.otherdetails
      @click="handleToggle"
    >
      <h5 class="text-primary font-weight-normal mb-0">Risk Details</h5>
    </div>
    <b-collapse id="otherdetails" :visible="initiallyExpanded">
      <ValidationObserver v-slot="{ passes }" class="channel-right">
        <form @submit.prevent="passes(handleSubmit)">
          <div class="body">
            <div class="row">
              <div class="col-sm-6 col-12">
                <div class="d-flex justify-content-between flex-wrap mb-3">
                  <label for="affiliatecode" class="control-label pr-2">
                    Affiliate Code:
                  </label>
                  <div>
                    <span>{{ othersDetails.affiliatecode ?? "N/A" }}</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between flex-wrap mb-3">
                  <label for="referredby" class="control-label pr-2">
                    Referred By:
                  </label>
                  <div>
                    <span v-if="othersDetails.referredby && othersDetails.referredby.payangelId">
                      {{ othersDetails.referredby.firstName }} {{ othersDetails.referredby.lastName }} ({{ othersDetails.referredby.payangelId }})
                    </span>
                    <span v-else>N/A</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between flex-wrap mb-3">
                  <label for="referralcode" class="control-label pr-2">
                    Referral Code:
                  </label>
                  <div>
                    <span>{{ othersDetails.referralcode ?? "N/A" }}</span>
                  </div>
                </div>
                <div class="form-group">
                  <span class="float-label">
                    <textarea
                      class="form-control"
                      id="notes"
                      v-model="othersDetails.notes"
                      placeholder="Alert"
                    ></textarea>
                    <label for="notes" class="control-label pr-2">Alert</label>
                    <div class="line"></div>
                  </span>
                </div>
                <div class="d-flex justify-content-between flex-wrap mb-3">
                  <label for="banktransfer" class="control-label pr-2">
                    Bank Transfer Only (Payment Method)?: *
                  </label>
                  <div>
                    <label class="fancy-radio">
                      <input
                        name="banktransfer"
                        :value="true"
                        v-model="othersDetails.isBankTransferOnly"
                        type="radio"
                        checked
                      />
                      <span>
                        <i></i>
                        Yes
                      </span>
                    </label>
                    <label class="fancy-radio">
                      <input
                        name="banktransfer"
                        :value="false"
                        v-model="othersDetails.isBankTransferOnly"
                        type="radio"
                      />
                      <span>
                        <i></i>
                        No
                      </span>
                    </label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="d-flex justify-content-between flex-wrap mb-3">
                    <label for="channel" class="control-label pr-2">
                      Passcode:
                    </label>
                    <div>
                      <span>N/A</span>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between flex-wrap mb-3">
                  <label for="customer_group" class="control-label pr-2">
                    Customer Group:
                  </label>
                  <div>
                    <span>{{ othersDetails.group?.name ?? "N/A" }}</span>
                  </div>
                </div>
                <div class="form-group">
                  <span class="float-label">
                    <input
                      type="text"
                      :value="othersDetails.group?.minLimit || 'N/A'"
                      class="form-control"
                      id="min_limit"
                      placeholder="Minimum Limit"
                      readonly
                    />
                    <label for="min_limit" class="control-label">
                      Minimum Limit
                    </label>
                    <div class="line"></div>
                  </span>
                </div>
                <div class="form-group">
                  <span class="float-label">
                    <input
                      type="text"
                      :value="othersDetails.group?.maxLimit || 'N/A'"
                      class="form-control"
                      id="max_limit"
                      placeholder="Maximum Limit"
                      readonly
                    />
                    <label for="max_limit" class="control-label">
                      Maximum Limit
                    </label>
                    <div class="line"></div>
                  </span>
                </div>
              </div>
              <div class="col-sm-6 col-12">
                <div class="d-flex justify-content-between flex-wrap mb-3">
                  <label for="mobilemoney" class="control-label pr-2">
                    Mobile Money AutoPay:
                  </label>
                  <div>
                    <label class="fancy-radio">
                      <input
                        name="mobilemoney"
                        :value="true"
                        v-model="othersDetails.mobileMoneyAutoPay"
                        type="radio"
                      />
                      <span>
                        <i></i>
                        Active
                      </span>
                    </label>
                    <label class="fancy-radio">
                      <input
                        name="mobilemoney"
                        :value="false"
                        v-model="othersDetails.mobileMoneyAutoPay"
                        type="radio"
                        checked
                      />
                      <span>
                        <i></i>
                        Disable
                      </span>
                    </label>
                  </div>
                </div>
                <div class="d-flex justify-content-between flex-wrap mb-3">
                  <label for="ibdmoney" class="control-label pr-2">
                    IBD Money AutoPay:
                  </label>
                  <div>
                    <label class="fancy-radio">
                      <input
                        name="ibdmoney"
                        :value="true"
                        v-model="othersDetails.ibdMoneyAutoPay"
                        type="radio"
                      />
                      <span>
                        <i></i>
                        Active
                      </span>
                    </label>
                    <label class="fancy-radio">
                      <input
                        name="ibdmoney"
                        :value="false"
                        v-model="othersDetails.ibdMoneyAutoPay"
                        type="radio"
                        checked
                      />
                      <span>
                        <i></i>
                        Disable
                      </span>
                    </label>
                  </div>
                </div>
                <div class="d-flex justify-content-between mb-3">
                  <p class="mb-0 mr-5 custom-switch-text">Super Affiliate</p>
                  <div class="custom-switch success-bg">
                    <input
                      type="checkbox"
                      class="custom-switch-input"
                      id="superaffiliate"
                      v-model="othersDetails.isSuperAffiliate"
                    />
                    <label class="custom-switch-label" for="superaffiliate">
                      <span class="custom-switch-text1">Yes</span>
                      <span class="custom-switch-text2">No</span>
                    </label>
                  </div>
                </div>
                <div
                  class="form-group datepicker"
                  v-if="othersDetails.isSuperAffiliate"
                >
                  <label for="affiliateStartDate" class="control-label pr-2">
                    Super Affiliate Start Date:
                  </label>
                  <span class="float-label">
                    <b-input-group>
                      <div class="input-group-prepend">
                        <span
                          class="input-group-text"
                          @click="$refs.affiliatedate.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                      </div>
                      <datepicker
                        class="form-control"
                        ref="affiliatedate"
                        v-model="othersDetails.affiliateStartDate"
                        :bootstrap-styling="false"
                        placeholder=""
                        :typeable="true"
                      ></datepicker>
                    </b-input-group>
                  </span>
                </div>
                <div class="d-flex justify-content-between flex-wrap mb-3">
                  <label for="channel" class="control-label pr-2">
                    Channel:
                  </label>
                  <div>
                    <span>{{ othersDetails.platform ?? "N/A" }}</span>
                  </div>
                </div>
                <ValidationProvider
                  name="riskStatus"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group form-select single-multiselect select-option-custom"
                    :class="{
                      errors: errors[0],
                      success: othersDetails.riskStatus && !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <label for="riskStatus">Block Status*</label>
                      <multiselect
                        placeholder=""
                        v-model="othersDetails.riskStatus"
                        :show-labels="false"
                        label="value"
                        :options="riskStatuses"
                      ></multiselect>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && errors[0]"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="othersDetails.riskStatus && !errors[0]"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <b-alert
              :show="loadState === 'failed'"
              variant="danger"
              class="d-flex align-items-center justify-content-between"
            >
              <span>
                Risk Details could not be loaded, so the details shown may be
                out of date. Saving is disabled until they load.
              </span>
              <b-button variant="outline-danger" size="sm" @click="loadData">
                Retry
              </b-button>
            </b-alert>
            <div class="d-flex flex-column flex-md-row justify-content-center">
              <b-button
                variant="secondary btn-mw"
                size="lg"
                @click="handleCancel"
              >
                Cancel
              </b-button>
              <b-button
                type="submit"
                variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                size="lg"
                :disabled="loadState !== 'ready'"
              >
                Submit
              </b-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </b-collapse>
  </div>
</template>

<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "@/plugins/vee-validate";
import { ISLOADING } from "@/store/mutations.type";
import {
  GET_CUSTOMER_OTHER_DETAILS,
  UPDATE_CUSTOMER_OTHER_DETAILS,
} from "@/store/actions.type.js";
import { myFunction } from "@/common/common-helper.js";

export default {
  name: "RiskDetails",
  components: {
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    Datepicker: () => import("vuejs-datepicker"),
  },
  props: {
    customerId: {
      type: String,
      required: true,
    },
    initiallyExpanded: {
      type: Boolean,
      default: false,
    },
    // Bumped by the page when another card may have changed the risk status.
    refreshKey: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      othersDetails: {},
      // "idle" until the card is first opened, then "loading", "ready" or "failed". Saving is
      // only allowed when "ready": after a failed reload the form still holds the previous
      // values, and submitting them would undo a change the backend made (e.g. Active after a
      // Silver upgrade).
      loadState: "idle",
      riskStatuses: [
        { value: "Active" },
        { value: "Monitor" },
        { value: "Restricted" },
        { value: "Suspended" },
        { value: "Terminated" },
        { value: "Blacklisted" },
      ],
    };
  },
  watch: {
    refreshKey() {
      // Not opened yet means there is nothing stale to replace; it loads fresh when opened.
      if (this.loadState !== "idle") {
        this.loadData();
      }
    },
  },
  mounted() {
    // If initially expanded, load data immediately
    if (this.initiallyExpanded) {
      this.loadData();
    }
  },
  methods: {
    async handleToggle() {
      // A failed load is retried when the card is reopened.
      if (this.loadState === "ready" || this.loadState === "loading") {
        return;
      }
      await this.loadData();
    },

    async loadData() {
      this.loadState = "loading";
      this.$store.commit(ISLOADING, true);
      return this.$store
        .dispatch(GET_CUSTOMER_OTHER_DETAILS, this.customerId)
        .then((response) => {
          const details = response?.status == 200 && response.data?.details;
          if (!details) {
            this.loadState = "failed";
            return;
          }
          this.othersDetails = {
            affiliatecode: details.affiliateCode,
            referredby: details.referredBy,
            referralcode: details.referralCode,
            isBankTransferOnly: details.isBankTransferOnly,
            mobileMoneyAutoPay: details.mobileMoneyAutoPay,
            ibdMoneyAutoPay: details.ibdMoneyAutoPay,
            affiliateStartDate: details.affiliateStartDate,
            isSuperAffiliate: !!details.affiliateStartDate,
            platform: details.platform,
            notes: details.notes,
            group: details.group,
            riskStatus: this.riskStatuses.find(
              (option) => option.value === (details.riskStatus ?? "Active"),
            ),
          };
          this.loadState = "ready";
        })
        .catch(() => {
          this.loadState = "failed";
        })
        .finally(() => {
          this.$store.commit(ISLOADING, false);
        });
    },

    handleSubmit() {
      if (this.loadState !== "ready") {
        return;
      }
      let params = {
        customerId: this.customerId,
        isBankTransferOnly: this.othersDetails.isBankTransferOnly,
        mobileMoneyAutoPay: this.othersDetails.mobileMoneyAutoPay,
        riskStatus:
          this.othersDetails.riskStatus.value === "Active"
            ? null
            : this.othersDetails.riskStatus.value,
        ibdMoneyAutoPay: this.othersDetails.ibdMoneyAutoPay,
        affiliateStartDate: this.othersDetails.isSuperAffiliate
          ? this.othersDetails.affiliateStartDate
          : null,
        notes: this.othersDetails.notes,
      };

      this.$store.commit(ISLOADING, true);

      this.$store
        .dispatch(UPDATE_CUSTOMER_OTHER_DETAILS, params)
        .then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.loadData();
            return;
          }

          myFunction.showInfo(response.data.message, "error");
        })
        .finally(() => {
          this.$store.commit(ISLOADING, false);
        });
    },

    handleCancel() {
      this.$router.push({ path: "/customer/list" });
    },
  },
};
</script>

<style scoped></style>
